import { apiGuestClient } from './apiGuestClient';

export const QUAN_HE_API_END_POINT = "quan-he";

export const quanHeApi = {
    // Lấy tất cả tôn giáo
    selectAll: () => apiGuestClient.get(`${QUAN_HE_API_END_POINT}`),
};
